"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const next_components_button_n_1 = __importDefault(require("@gerenciatd/next.components.button-n"));
const Header4Section = (props) => {
    const items = props.pills ? Object.values(props.pills) : null;
    if (!items) {
        return null;
    }
    let i = 0;
    return (react_1.default.createElement("div", { className: "header4-section" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "pill-section", "data-cy": "Header pills" }, items.map((item) => {
                const link = item.link ? item.link : "#";
                const { text } = item;
                const active = item.selected;
                return (react_1.default.createElement("div", { key: `item-${i++}`, className: "pill-item" },
                    react_1.default.createElement(next_components_button_n_1.default, { href: link || null, target: item.target_link || '_self', label: text, buttonType: active ? "tab_active" : "tab", height: "normal", width: "medium", className: "buttonx", taggingInfo: {
                            componentName: "header",
                            componentVariation: "tab",
                            componentContent: text,
                            componentPerso: "",
                            componentProduct: "",
                        } })));
            })))));
};
exports.default = Header4Section;
//# sourceMappingURL=index.js.map